import React from "react";
import LeftImg from './images/services/crm-img.png'
import Icon01 from './images/services/crm-1.png'
import Icon02 from './images/services/crm-2.png'
import Icon03 from './images/services/crm-3.png'
import Icon04 from './images/services/crm-4.png'
import Icon05 from './images/services/crm-5.png'
function CRMInfo() {
  return (
    <section className="image-description-section section">
        <p className="section-heading">Ensures that your remote field force is where they are supposed to be!</p>
    <div className="image-description-left image-section-left">
        <img src={LeftImg} alt="Description Image" className="image_description"
        style={{filter:'invert(0)'}}
        />
    </div>
    <div className="image-description-right description">
        <h2 className="heading-underline">Key Features</h2>
        <p className="description-para">
            <img src={Icon01} width={30} height={30} className="img-fluid" alt="icons"/>
            Locate personnel by location



 </p>
        <p className="description-para">
            <img src={Icon02} width={30} height={30} className="img-fluid" alt="icons"/>
            Check-In & Check-Out by Location
 </p>
        <p className="description-para">
            <img src={Icon03} width={30} height={30} className="img-fluid" alt="icons"/>
            Manage attendance and leaves

  </p>
        <p className="description-para">
            <img src={Icon04} width={30} height={30} className="img-fluid" alt="icons"/>
            Simple to set-up & use
 </p>
        <p className="description-para">
            <img src={Icon05} width={30} height={30} className="img-fluid" alt="icons"/>
            Reports and dashboard for managers
 </p>

    </div>
</section>  
  )
}
export default CRMInfo;